import { Link } from "react-router-dom";
import { site } from "../../data/content";
import { MapPin, EnvelopeSimple, Phone, Globe } from "@phosphor-icons/react";

const cols = [
    {
        title: "Company",
        links: [
            { label: "About Us", to: "/about" },
            { label: "Careers", to: "/careers" },
            { label: "Contact Us", to: "/contact" },
            { label: "Why FRONTX", to: "/why-frontx" },
        ],
    },
    {
        title: "Services",
        links: [
            { label: "Contract Staffing", to: "/services" },
            { label: "Temporary Staffing", to: "/services" },
            { label: "Permanent Recruitment", to: "/services" },
            { label: "Bulk Hiring", to: "/services" },
            { label: "Payroll Management", to: "/services" },
            { label: "Workforce Management", to: "/services" },
            { label: "Construction Services", to: "/construction" },
        ],
    },
    {
        title: "Industries",
        links: [
            { label: "Agriculture", to: "/industries" },
            { label: "Construction", to: "/construction" },
            { label: "Manufacturing", to: "/industries" },
            { label: "Logistics", to: "/industries" },
            { label: "BPO / BPM", to: "/services" },
            { label: "IT & AI", to: "/industries" },
            { label: "Healthcare", to: "/industries" },
            { label: "Education", to: "/industries" },
            { label: "E-commerce", to: "/industries" },
        ],
    },
];

export const Footer = () => (
    <footer className="relative bg-navy text-slate-300 grain overflow-hidden" data-testid="footer">
        <div className="relative z-10 mx-auto max-w-[1400px] px-5 lg:px-10 pt-24 pb-10">
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-10">
                <div className="col-span-2 lg:col-span-3">
                    <Link to="/" className="flex items-center gap-3">
                        <img src={site.logo} alt="FRONTX" className="h-12 w-12 rounded-sm ring-1 ring-white/15" />
                        <span className="font-display font-extrabold text-white text-2xl tracking-tight">FRONTX</span>
                    </Link>
                    <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-400">
                        FRONTX Integrated Services India Private Limited is a PAN India integrated manpower,
                        staffing, workforce management and construction services company — supporting organizations
                        with both workforce deployment and project execution.
                    </p>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li className="flex items-center gap-3"><Globe size={18} className="text-brand" /> <a href={site.websiteUrl} className="hover:text-white">{site.website}</a></li>
                        <li className="flex items-center gap-3"><EnvelopeSimple size={18} className="text-brand" /> <a href={`mailto:${site.email}`} className="hover:text-white">{site.email}</a></li>
                        {site.phone && (
                            <li className="flex items-center gap-3"><Phone size={18} className="text-brand" /> <a href={`tel:${site.phoneRaw}`} className="hover:text-white">{site.phone}</a></li>
                        )}
                        <li className="flex items-center gap-3"><MapPin size={18} className="text-brand" /> {site.address}</li>
                    </ul>
                </div>
                {cols.map((c) => (
                    <div key={c.title}>
                        <h4 className="text-xs uppercase tracking-[0.2em] text-white font-semibold mb-5">{c.title}</h4>
                        <ul className="space-y-3">
                            {c.links.map((l, i) => (
                                <li key={i}>
                                    <Link to={l.to} className="text-sm text-slate-400 hover:text-brand transition-colors">{l.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <p className="text-xs text-slate-500">
                    © {new Date().getFullYear()} {site.name}. CIN: {site.cin}. All rights reserved.
                </p>
                <div className="flex items-center gap-6 text-xs text-slate-400">
                    <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
                    <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
                    <Link to="/disclaimer" className="hover:text-white">Disclaimer</Link>
                </div>
            </div>
        </div>

        <div className="relative z-0 select-none pointer-events-none -mb-6 lg:-mb-14 text-center leading-none">
            <span className="font-display font-extrabold text-outline text-[22vw] tracking-tighter">FRONTX</span>
        </div>
    </footer>
);
